import styled from 'styled-components';

export default styled.text`
  font-size: 14px;
  color: black;
  user-select: none;
  pointer-events: none;
`;
